export const isFalsy = value => !value



// WEBPACK FOOTER //
// ./src/utils/boolean/isFalsy.js